import React from 'react';

import Cabecalho from 'Component/Cabecalho';
import Icone from 'Component/Icone';
import LayoutDefault from 'Component/Layout';
import { CalculadoraTurnover } from 'Interface/VinculosEmpregaticios';
import { useRecuperarCalculadoraTurnoverVinculosEmpregaticiosQuery } from 'View/Service/Default/VinculosEmpregaticios';

const Default = (): React.ReactElement => {
  const {
    data: { vinculos: [vinculo] } = { vinculos: [{} as CalculadoraTurnover] },
    isFetching,
  } = useRecuperarCalculadoraTurnoverVinculosEmpregaticiosQuery({
    finder: 'calculadoraTurnover',
  });

  return (
    <LayoutDefault>
      <Cabecalho
        titulo="Calculadora de Turnover"
        descricao="Calcule aqui a taxa de Turnover da empresa"
      />
      <div className="row justify-content-center h-100">
        <div className="col-md-6 h-100 d-flex flex-column justify-content-center align-items-center">
          <span style={{ fontSize: '5rem' }}>
            <Icone nome="calculator-fill" className="text-primary" />
          </span>
          {isFetching ? (
            <div className="d-block text-center">
              <p className="fs-1 text-center">
                Selecione um ano e um mês para realizar o calculo da taxa de
                Turnover
              </p>
            </div>
          ) : (
            <div>
              {vinculo.total == 0 ? (
                <p className="display-1 text-center">0%</p>
              ) : (
                <p className="display-1 text-center">
                  {((vinculo.total_admissao +
                    vinculo.total_rescisao) /
                    2 /
                    vinculo.total) *
                    100}
                  %
                </p>
              )}
              <p className="text-center mb-5">
                <b>Indicadores isolados</b>
                <br />
                Total de admissão: {vinculo.total_admissao}
                <br />
                Total de rescisão: {vinculo.total_rescisao}
                <br />
                Total de funcionários atualmente: {vinculo.total}
                <br />
              </p>
            </div>
          )}
          <p className="text-center fs-5 text-muted">
            A taxa de Turnover é calculada usando a seguinte formula
            <br />
            [(Admissões + desligamentos) ÷2] ÷ total de funcionários atualmente
            x 100
          </p>
        </div>
      </div>
    </LayoutDefault>
  );
};

export default Default;
